import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AppProvider } from "./context";
import Header from "./Header";
import Footer from "./Footer";
import HomePage from "./HomePage";
import ListingsPage from "./ListingsPage";
import ApartmentDetailPage from "./ApartmentDetailPage";
import { ServicesPage, AboutPage, FAQPage, ContactPage } from "./StaticPages";
import { AdminLogin, AdminDashboard, AdminApartments, AdminBookings } from "./AdminPages";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main style={{ minHeight: "60vh" }}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/apartments" element={<ListingsPage />} />
            <Route path="/apartments/:slug" element={<ApartmentDetailPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/apartments" element={<AdminApartments />} />
            <Route path="/admin/bookings" element={<AdminBookings />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </AppProvider>
  );
}
